import axios from 'axios'
import { decryptData, encryptData } from './tweetnacl'

const apiCall = async (
    method,
    url,
    data,
    headertype,
    baseurl,
    common,
    custom,
    front
) => {
    if (global.decryptData && data) {
        data = data instanceof FormData ? data : encryptData(data)
    }
    let site_url = `${global.site_url}/api/admin/`
    if (baseurl) {
        site_url = `${global.site_url}/api/admin/${baseurl}/`
    }

    if (common) {
        site_url = `${global.site_url}/api/commonFunction/`
        if (baseurl) {
            site_url = `${global.site_url}/api/commonFunction/${baseurl}/`
        }
    }

    if (custom) {
        site_url = `${global.site_url}/api/custom/`
        if (baseurl) {
            site_url = `${global.site_url}/api/custom/${baseurl}/`
        }
    }

    if (front) {
        site_url = `${global.site_url}/api/`
        if (baseurl) {
            site_url = `${global.site_url}/api/${baseurl}/`
        }
    }

    const contentType =
        headertype && headertype === 'formdata'
            ? 'multipart/form-data'
            : 'application/json'

    const config = {
        headers: { 'content-type': contentType },
    }

    try {
        let res
        if (method === 'post') {
            res = await axios.post(`${site_url}${url}`, data || {}, config)
        } else if (method === 'get') {
            res = await axios.get(`${site_url}${url}`, config)
        } else {
            throw new Error(`Unsupported method: ${method}`)
        }

        if (global.decryptData && res.data) {
            res.data =
                data instanceof FormData ? res.data : decryptData(res.data)
        }

        return res
    } catch (err) {
        console.error('API Error:', err?.message || err)

        if (err.code === 'ECONNABORTED') {
            return {
                data: {
                    status: 'error',
                    data: {
                        message: 'Request timed out. Please try again later.',
                    },
                },
            }
        }

        if (err.response) {
            let respData = err.response.data
            if (global.decryptData && respData) {
                respData = decryptData(respData)
            }
            return {
                data: {
                    status: 'error',
                    data: {
                        message: respData?.message || 'Server Error',
                        statusCode: err.response.status,
                    },
                },
            }
        }

        return {
            data: {
                status: 'error',
                data: {
                    message: err.message || 'Something went wrong!',
                },
            },
        }
    }
}

const setAuthToken = (token) => {
    if (token) {
        axios.defaults.headers.common['authorization'] = `Bearer ${token}`
    } else {
        delete axios.defaults.headers.common['authorization']
    }
}

const setIPAddress = (ipaddress) => {
    if (ipaddress) {
        axios.defaults.headers.common['ipaddress'] = ipaddress
    } else {
        delete axios.defaults.headers.common['ipaddress']
    }
}
export { apiCall, setAuthToken, setIPAddress }
